import { CheckboxActiveIcon, DropdownIcon } from "app/components/Icons";
import CheckboxIcon from "app/components/Icons/CheckboxIcon";
import clsx from "clsx";
import React from "react";
import { TicketGroup } from "../../types";

interface GroupHeaderBarActionsProps {
  group: TicketGroup;
  isSelected: boolean;
  handleSelectAll: () => void;
  handleCollapsed: () => void;
}

const GroupHeaderBarActions: React.FC<GroupHeaderBarActionsProps> = ({
  isSelected,
  group,
  handleCollapsed,
  handleSelectAll,
}) => {
  return (
    <div
      className={` flex items-center absolute -left-[64px] w-[62px]  h-full ${
        isSelected ? "!bg-[#E7F1FF]" : "group-hover:bg-[#ECEEF2] bg-[#F4F5F7] h-full  "
      }`}
    >
      <div className={`flex items-center gap-[2px] w-full   `}>
        <button className=" size-[18px] flex justify-center items-center opacity-0  "></button>
        {isSelected ? (
          <button
            className="size-[18px] flex items-center  "
            onClick={(e) => {
              e.stopPropagation();
              handleSelectAll();
            }}
          >
            <CheckboxActiveIcon />
          </button>
        ) : (
          <button
            className="size-[18px] flex items-center opacity-0 group-hover:opacity-100 "
            onClick={(e) => {
              e.stopPropagation();
              handleSelectAll();
            }}
          >
            <CheckboxIcon size={18} />
          </button>
        )}
        <button
          className={clsx(
            "flex items-center justify-center w-[24px] h-[24px] transition-transform",
            group.isCollapse ? "-rotate-90" : "rotate-0"
          )}
          onClick={(e) => {
            e.stopPropagation();
            handleCollapsed();
          }}
        >
          <DropdownIcon size={20} />
        </button>
      </div>
    </div>
  );
};

export default GroupHeaderBarActions;
